import { tiers } from "app/config";
import { useTheme } from "app/shared";

import styles from "./CommissionTiers.module.scss";

const CommissionTiers = ({ totalClaimed }: { totalClaimed: number }) => {
  const { theme } = useTheme();

  const currentTier =
    tiers.find((tier) => totalClaimed >= tier.min) || tiers[tiers.length - 1];
  const progress = Math.min(100, (totalClaimed / 10000) * 100);

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h3 className={styles.title}>Your Referral Commission Tier</h3>
      <div className={styles.progressContainer}>
        <div
          className={styles.progressBar}
          style={{
            width: `${progress}%`,
            backgroundColor: currentTier.color,
          }}
        />
        <div className={styles.progressLabels}>
          {tiers.map((tier, index) => (
            <div
              key={tier.name}
              className={styles.progressLabel}
              style={{
                left: `${(tier.min / 10000) * 100}%`,
                color: totalClaimed >= tier.min ? tier.color : "#888",
              }}
            >
              ${tier.min.toLocaleString()}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.tiersContainer}>
        {tiers.map((tier) => (
          <div
            key={tier.name}
            className={`${styles.tier} ${
              currentTier.name === tier.name ? styles.activeTier : ""
            }`}
            style={{
              borderColor: tier.color,
              backgroundColor:
                currentTier.name === tier.name
                  ? `${tier.color}20`
                  : "transparent",
            }}
          >
            <div className={styles.tierHeader}>
              <span className={styles.tierName} style={{ color: tier.color }}>
                {tier.name}
              </span>
              {currentTier.name === tier.name && (
                <span className={styles.currentBadge}>Current</span>
              )}
            </div>
            <div className={styles.tierDescription}>{tier.description}</div>
            <div className={styles.tierRange}>{tier.range}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommissionTiers;
